module.exports = __webpack_public_path__ + "static/media/DSC_0228.bd9e5170.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0228.jpg
// module id = 569
// module chunks = 0